import axios from 'axios';

// Create a dedicated client for support endpoints
const supportAxios = axios.create({
  baseURL: (process.env.REACT_APP_API_URL || 'http://localhost:5000/api')
    .replace(/\/auth$/, '') + '/support',
  withCredentials: true
});

export default supportAxios;